import { render } from "./SeleccionPosicion.vue?vue&type=template&id=4cd6d075&scoped=true"
import script from "./SeleccionPosicion.vue?vue&type=script&lang=js"
export * from "./SeleccionPosicion.vue?vue&type=script&lang=js"

import "./SeleccionPosicion.vue?vue&type=style&index=0&id=4cd6d075&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cd6d075"]])

export default __exports__